/**
 * @generated SignedSource<<3cfe9dea7890e6064611343d46e67dea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "authApiServiceAllStaticContentUrlsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StaticContentUrlNodeConnection",
        "kind": "LinkedField",
        "name": "allStaticcontenturls",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StaticContentUrlNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "StaticContentUrlNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v0/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "authApiServiceAllStaticContentUrlsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StaticContentUrlNodeConnection",
        "kind": "LinkedField",
        "name": "allStaticcontenturls",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StaticContentUrlNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "StaticContentUrlNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "530c4639ee4d4678fcdf02b37a3216a7",
    "id": null,
    "metadata": {},
    "name": "authApiServiceAllStaticContentUrlsQuery",
    "operationKind": "query",
    "text": "query authApiServiceAllStaticContentUrlsQuery {\n  allStaticcontenturls {\n    edges {\n      node {\n        url\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

node.hash = "163c85bf892ec99c677f9e6bf3ccfcd4";

module.exports = node;
